import { FC } from 'react';

import { GiftLegalTextWrapper, LegalTextWrapper } from './LegalText.styles';

type Props = {
    dataTest?: string;
    legalText: string;
};

export const GiftLegalText: FC<Props> = ({ dataTest, legalText }) => {
    if (!legalText) {
        return null;
    }

    return (
        <GiftLegalTextWrapper>
            <LegalTextWrapper dataTest={dataTest} content={legalText} />
        </GiftLegalTextWrapper>
    );
};
